import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { FreeMode, Autoplay } from "swiper";
import abhik from '../../img/Abhik.jpeg';
import Menus from '../../img/Menus.jpeg';
import Chahat from '../../img/Chahat.jpeg';
import Piyus from '../../img/PiyushGoyal.jpeg';
import Arfaa from '../../img/Arfaa.jpeg';
import Shivani from '../../img/ShivaniSaluja.png';
import Muskan from '../../img/Dr.Muskan.png';
import Stuti from '../../img/StutiAjmera.jpeg';
import Nikita from '../../img/NikitaYadav.jpeg';

const OurCounselors = () => {
    const blogs = [
        { title1: 'SDE at Google', title2: 'Gsoc Mentee- 2020', title3: 'Gsoc mentor - 2021', name: 'Abhik', image: abhik },
        { title1: 'B Tech Biotechnology IIT Roorkee,', title2: 'MSc in Drug Discovery,', title3: 'Memorial University of Newfoundland (Fully funded)', name: 'Menus Garg', image: Menus },

        { title1: 'MBBS', title2: 'GSS govt. medical college', name: 'Dr. Chahat', image: Chahat },
        { title1: 'Chartered accountant', name: 'Piyus Goyal', image: Piyus },
        { title1: 'B.SC. BIOTECHNOLOGY', name: 'Arfaa', image: Arfaa },
        { title1: 'MSc in Chemistry', name: 'Shivani Saluja', image: Shivani },
        { title1: 'BPT Intern , GB pant hospital, Delhi', name: 'Dr. Muskan (PT)', image: Muskan },
        { title1: 'IIM Kashipur', name: 'Stuti Ajmera', image: Stuti },
        { title1: 'B.ed Entrance Ranker', name: 'Nikita Yadav', image: Nikita }

    ];

    return (
        <div className='pt-14'>
            <h1 className='text-center text-2xl md:text-5xl font-bold'>Our <span className='text-orange-400'>Counselors</span>/<span className='text-blue-800'>Mentors</span></h1>
            <div className=" my-10">
                <Swiper
                    breakpoints={{
                        // when window width is >= 640px
                        640: {
                            width: 640,
                            slidesPerView: 1,
                        },
                        // when window width is >= 768px
                        768: {
                            width: 768,
                            slidesPerView: 3,
                        },
                        1024: {
                            width: 1024,
                            slidesPerView: 3,
                        },
                    }}
                    slidesPerView={1}
                    spaceBetween={10}
                    freeMode={true}
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{ delay: 3000 }}
                    modules={[FreeMode, Autoplay]}
                    className=""
                >
                    {
                        blogs?.map((blog, i) => <SwiperSlide key={i} className='p-4 cursor-pointer'>
                            <img src={blog?.image} alt="" className="rounded-full w-full h-72" />
                            <div className="mt-3">
                                <p className="text-2xl font-semibold text-center">{blog?.name}</p>
                                <h4 className="text-sm font-semibold text-center">{blog?.title1}</h4>
                                <h4 className="text-sm font-semibold text-center">{blog?.title2}</h4>
                                <h4 className="text-sm font-semibold text-center">{blog?.title3}</h4>
                            </div>
                        </SwiperSlide>)
                    }

                </Swiper>
            </div>
        </div>
    );
};

export default OurCounselors;